import React, { useState, useMemo } from 'react';
import { useTranslation, useDocumentTitle } from '@core/hooks';

interface WithTitleEnhanced {
  title?: string | null;
  setCustomTitle?: React.Dispatch<React.SetStateAction<string | null>>;
}

type WrappedComponent<TProps> = (
  props: TProps & WithTitleEnhanced,
  context?: any
) => React.ReactElement | null;

const withTitle = <TWrappedProps,>(
  WrappedComponent: WrappedComponent<TWrappedProps>,
  title: string
) => (props: TWrappedProps) => {
  const [customTitle, setCustomTitle] = useState<string | null>(null);

  const { t } = useTranslation();

  useDocumentTitle(customTitle || title);

  const titleToDisplay = useMemo(() => {
    if (customTitle) {
      return customTitle;
    }

    return t(title || ' ');
  }, [title, customTitle]);

  return (
    <>
      <h2 className="page-title">{titleToDisplay}</h2>
      <WrappedComponent
        title={titleToDisplay}
        setCustomTitle={setCustomTitle}
        {...props}
      />
    </>
  );
};

export default withTitle;
